/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable arrow-body-style */
/* eslint-disable object-curly-newline */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
import { TRAINING_TYPE_CAREER, TRAINING_TYPE_CURRICULUM } from "../../Constants";
import Environments from "../../Environments";
import MOCK_DATA from "../../mock/data";

import CategoryCareerTreeService, { CategoryCareerTreeResponse, TreeListItem } from "../api/CategoryCareerTreeService";
import OnGoingCULGridListService, { OnGoingCULGridListItem } from "../api/OnGoingCULGridListService";
import ResultCULGridListService, { ResultCULGridListItem } from "../api/ResultCULGridListService";
import CategoryTreeService, { CategoryTreeResponse, CategoryTreeItem } from "../api/CategoryTreeService";
import { showErrorMessage } from "./useDialogStateHelper";

const categoryCareerTreeService = new CategoryCareerTreeService();
const onGoingCULService = new OnGoingCULGridListService();
const resultCULService = new ResultCULGridListService();
const categoryTreeService = new CategoryTreeService();

/** 分類名：SOMPO NEWS */
const CATEGORY_NAME_SOMPO_NEWS = "SOMPO NEWS";

/** 分類名：情報発信 */
const CATEGORY_NAME_SUBMISSION = "情報発信";

/** 分類ツリー：研修の分類ID */
export const CATEGORY_ID_CAREERS = `#${TRAINING_TYPE_CAREER}`;

/** 分類ツリー：カリキュラムの分類ID */
export const CATEGORY_ID_CURRICULUMS = `#${TRAINING_TYPE_CURRICULUM}`;

/** 分類選択なし(すべて)時のcategoryId */
export const CATEGORY_ID_ALL = "-1";
export const CATEGORY_NAME_ALL = "すべて";

export interface Category {
    id: string;
    name: string;
    parentId: string;
    level: number;
    subCategories?: Category[];
}
/** 第2階層分類を表すインターフェース */
export interface MainCategory {
    id: string;
    name: string;
}

/** 分類のリスト 一覧 */
const CATEGORIES: Set<Category> = new Set();
/** 分類のリスト 階層別 */
const LEVEL_CATEGORIES: Map<string, Category[]> = new Map();

/** 講座ID - 分類の所属：<講座ID, 分類(第2階層)>のMap */
const CAREERS: Map<string, MainCategory> = new Map();

/** [分類：SOMPO NEWS]に含まれる講座IDを格納したSet */
const SOMPO_NEWS: Set<string> = new Set();

/** [分類：情報発信]に含まれる講座IDを格納したSet */
const SUBMISSION: Set<string> = new Set();

const setCategories = (parentId: string, category: Category) => {
    CATEGORIES.add(category);
    const target: Category[] = [];
    const _target = LEVEL_CATEGORIES.get(parentId);
    LEVEL_CATEGORIES.delete(parentId);
    if (_target) {
        target.push(..._target);
    }
    if (target.findIndex((item) => item.id === category.id) < 0) {
        target.push(category);
    }
    LEVEL_CATEGORIES.set(parentId, target);
};

/** カリキュラム：分類のリスト 一覧 */
const CURRICULUM_CATEGORIES: Set<Category> = new Set();
/** カリキュラム：分類のリスト 階層別 */
const CURRICULUM_LEVEL_CATEGORIES: Map<string, Category[]> = new Map();
/** カリキュラム：カリキュラムID - 分類の所属：<講座ID, 分類(第2階層)>のMap */
const CURRICULUMS: Map<string, MainCategory> = new Map();
const CURRICULUM_HISTORIES = new Set<OnGoingCULGridListItem | ResultCULGridListItem>();
const hasCurriculumHistories = () => CURRICULUM_HISTORIES.size !== 0;
const hasCurriculumCategories = () => CURRICULUM_CATEGORIES.size !== 0;
const showCurriculums = () => hasCurriculumCategories() || hasCurriculumHistories();

const setCurriculumCategories = (parentId: string, category: Category) => {
    CURRICULUM_CATEGORIES.add(category);
    const target: Category[] = [];
    const _target = CURRICULUM_LEVEL_CATEGORIES.get(parentId);
    CURRICULUM_LEVEL_CATEGORIES.delete(parentId);
    if (_target) {
        target.push(..._target);
    }
    if (target.findIndex((item) => item.id === category.id) < 0) {
        target.push(category);
    }
    CURRICULUM_LEVEL_CATEGORIES.set(parentId, target);
};

/**
 * (内部用) 特殊な講座IDのSetを初期化する。
 *
 * @param set 設定対象のSet
 * @param category 設定対象のTreeListItem
 */
const setupSet = (set: Set<string>, category: TreeListItem) => {
    set.clear();
    (category.children || []).forEach((news: TreeListItem) => set.add(news.id));
};

let sompoNewsCategoryId: string;
const setSompoNewsCategory = (categoryId: string) => {
    sompoNewsCategoryId = categoryId;
};
/**
 * SOMPO NEWSの分類IDを取得する。
 * @returns SOMPO NEWSの分類ID
 */
const getSompoNewsCategoryId = () => sompoNewsCategoryId;

/**
 * (内部用) SOMPO NEWSの講座リストを初期化する。
 *
 * @param category SOMPO NEWSの分類ツリー
 */
const setupSompoNews = (category: TreeListItem) => {
    setSompoNewsCategory(category.id);
    setupSet(SOMPO_NEWS, category);
};

/** 情報発信の分類ID */
let submissionCategoryId: string;
const setSubmissionCategory = (categoryId: string) => {
    submissionCategoryId = categoryId;
};
/**
 * 情報発信の分類IDを取得する。
 * @returns 情報発信の分類ID
 */
export const getSubmissionCategoryId = () => submissionCategoryId;

/**
 * (内部用) 情報発信の講座リストを初期化する。
 *
 * @param category 情報発信の分類ツリー
 */
const setupSubmission = (category: TreeListItem) => {
    setSubmissionCategory(category.id);
    setupSet(SUBMISSION, category);
};

/**
 * (内部用)ある講座が指定のSetに含まれるか確認する。
 *
 * @param set 探す対象のSet
 * @param careerId 講座ID
 *
 * @returns 指定のSetに含まれる場合、true。
 */
const containsInSet = (set: Set<string>, careerId: string) => set.has(careerId);

/**
 * 指定された講座がSOMPO NEWSに属するか確認する。
 *
 * @param careerId 講座ID
 *
 * @returns 指定された講座がSOMPO NEWSの場合、true。
 */
const isSompoNews = (careerId: string) => containsInSet(SOMPO_NEWS, careerId);

/**
 * 指定された講座が情報発信に属するか確認する。
 *
 * @param careerId 講座ID
 *
 * @returns 指定された講座が情報発信の場合、true。
 */
const isSubmission = (careerId: string) => containsInSet(SUBMISSION, careerId);

/**
 * 対象の講座の所属カテゴリ(第2階層)を取得する。
 * @param careerId
 * @returns
 */
const getMainCategory = (careerId: string) => CAREERS.get(careerId);

/**
 * 対象カテゴリの子のカテゴリを取得する
 * @param parentId
 * @returns
 */
const getLevelCategories = (parentId: string) => {
    // console.log("getLevelCategories", parentId);
    return LEVEL_CATEGORIES.get(parentId);
};

const getMainCategoryCurriculum = (careerId: string) => CURRICULUMS.get(careerId);
const getLevelCategoriesCurriculum = (parentId: string) => {
    // console.log("getLevelCategoriesCurriculum", parentId);
    return CURRICULUM_LEVEL_CATEGORIES.get(parentId);
};

/**
 * 分類のリスト、講座ID - 分類の所属のMapを作成する
 * @param category
 * @returns
 */
const setupCareers = (category: TreeListItem, rootCategory?: TreeListItem) => {
    const _root = rootCategory || category;
    const children = category.children?.map((item) => ({ id: item.id, name: item.text, parentId: category.id, level: parseInt(item.level, 10) }));
    const _category = {
        id: category.id,
        name: category.text,
        parentId: category.parent,
        level: parseInt(category.level, 10),
        subCategories: children,
    };
    // 講座リストを作成する。
    if (category.id.indexOf("CS") === 0) {
        const career = category;
        CAREERS.set(career.id, { id: _root.id, name: _root.text });
        return;
    }
    setCategories(category.parent, _category);

    if (category.hasChildren) {
        (category.children || []).forEach((item) => {
            setupCareers(item, _root);
        });
    }
};

const setupCurriculums = (category: TreeListItem, rootCategory?: TreeListItem) => {
    const _root = rootCategory || category;
    const children = category.children?.map((item) => ({ id: item.id, name: item.text, parentId: category.id, level: parseInt(item.level, 10) }));
    const _category = {
        id: category.id,
        name: category.text,
        parentId: category.parent,
        level: parseInt(category.level, 10),
        subCategories: children,
    };
    // 講座リストを作成する。
    if (category.id.indexOf("CU") === 0) {
        const career = category;
        CURRICULUMS.set(career.id, { id: _root.id, name: _root.text });
        return;
    }
    setCurriculumCategories(category.parent, _category);

    if (category.hasChildren) {
        (category.children || []).forEach((item) => {
            setupCurriculums(item, _root);
        });
    }
};

const getTargetCareer = (categoryId: string): Category[] => {
    const mainCategories = Array.from(CATEGORIES).find((item) => item.id === categoryId);
    if (!mainCategories) return [];
    const careers: Category[] = [];
    (mainCategories.subCategories || []).forEach((item) => {
        if (item.id.indexOf("CS") === 0) {
            careers.push(item);
        }
        const subCareers = getTargetCareer(item.id);
        careers.push(...subCareers);
    });

    return careers;
};

/**
 * 分類データの取得、設定を行う
 */
const getCategoryData = () => {
    // fetchだけ先に済ませる
    let careerTree: TreeListItem | undefined;
    const dataSet = (treeList: TreeListItem[]) => {
        /* ==================================
         * 講座
         * ==================================
         */
        // 研修のツリーを抜き出し：コレだけが作業対象
        careerTree = (treeList || []).find((e: TreeListItem) => e.id === CATEGORY_ID_CAREERS);

        // 講座データをクリア
        CATEGORIES.clear();
        CAREERS.clear();
        LEVEL_CATEGORIES.clear();
        SOMPO_NEWS.clear();
        SUBMISSION.clear();

        // 分類ごとで処理分け
        (careerTree?.children || []).forEach((rootCategory: TreeListItem) => {
            // 講座を分類でグルーピングする。
            setupCareers(rootCategory);

            switch (rootCategory.text) {
                // SOMPO NEWSは講座比較用に講座IDをリストしておく
                // ホーム：SOMPONEWSを表示するために使用する
                case CATEGORY_NAME_SOMPO_NEWS:
                    setupSompoNews(rootCategory);
                    break;

                // 情報発信は講座比較用に講座IDをリストしておく
                // ホーム：情報発信を表示するために使用する
                case CATEGORY_NAME_SUBMISSION:
                    setupSubmission(rootCategory);
                    break;

                default:
                    break;
            }
        });

        /* ==================================
         * カリキュラム
         * ==================================
         */
        // カリキュラムのツリーを抜き出し：コレだけが作業対象
        const curriculumTree = (treeList || []).find((e: TreeListItem) => e.id === CATEGORY_ID_CURRICULUMS);

        // 既存データをクリア
        CURRICULUM_CATEGORIES.clear();
        CURRICULUMS.clear();
        CURRICULUM_LEVEL_CATEGORIES.clear();
        CURRICULUM_HISTORIES.clear();

        // カテゴリデータ作成
        (curriculumTree?.children || []).forEach((rootCategory: TreeListItem) => {
            // カリキュラムを分類でグルーピングする。
            // console.log("useCategories: Curriculum category", rootCategory);
            setupCurriculums(rootCategory);
        });
    };

    // 分類データ（カテゴリ）取得
    const fetch = async () => {
        if (!Environments.MOCK) {
            try {
                await categoryCareerTreeService.categoryCareerTree(
                    {},
                    (response: CategoryCareerTreeResponse) => {
                        dataSet(response.treeList);
                    },
                    (error: any) => {
                        throw error;
                    }
                );

                // カリキュラムの履歴をfetch
                await onGoingCULService.fetch().then((response) => {
                    (response.onGoingCULGridList || []).forEach((o) => CURRICULUM_HISTORIES.add(o));
                });
                await resultCULService.fetch().then((response) => {
                    (response.resultCULGridList || []).forEach((r) => CURRICULUM_HISTORIES.add(r));
                });
            } catch (error: any) {
                console.error(error);
                showErrorMessage({ message: "分類マスタのデータ取得に失敗しました。", error });
            }
        } else {
            dataSet(MOCK_DATA.CATEGORY_TREE);
        }
    };
    void fetch();
};

/**
 * (旧)カテゴリのデータを取得するカスタムフック.<br/>
 * ※レンダリング単位でfetchが発生し、低パフォーマンスのため非推奨化.<br/>
 *
 * @returns カテゴリ(分類)関連のデータ
 * @deprecated useCategories2の利用を検討すること
 */
export const useCategories = () => {
    getCategoryData();
    return {
        // 講座
        categoriesData: Array.from(CATEGORIES),
        careersData: CAREERS,
        isSompoNews,
        isSubmission,
        getTargetCategory: getMainCategory,
        getLevelCategories,
        getTargetCareer,
        getSompoNewsCategoryId,
        getSubmissionCategoryId,

        // カリキュラム
        CURRICULUMS: Array.from(CURRICULUM_CATEGORIES),
        getMainCategoryCurriculum,
        getLevelCategoriesCurriculum,
        showCurriculums,
    };
};

export interface Categories {
    // 講座：全般
    categoriesData: Category[];
    careersData: Map<string, MainCategory>;
    getTargetCategory: (careerId: string) => MainCategory | undefined;
    getLevelCategories: (parentId: string) => Category[] | undefined;
    getTargetCareer: (categoryId: string) => Category[];

    // 講座：SOMPO NEWS
    getSompoNewsCategoryId: () => string;
    isSompoNews: (careerId: string) => boolean;

    // 講座：情報発信
    getSubmissionCategoryId: () => string;
    isSubmission: (careerId: string) => boolean;

    // カリキュラム関連
    CURRICULUMS: Category[];
    getMainCategoryCurriculum: (careerId: string) => MainCategory | undefined;
    getLevelCategoriesCurriculum: (parentId: string) => Category[] | undefined;
    showCurriculums: () => boolean;
}
export const CATEGORIES_DEFAULT: Categories = {
    // 講座：全般
    categoriesData: [],
    careersData: new Map<string, MainCategory>(),
    getTargetCategory: (careerId: string) => undefined,
    getLevelCategories: (parentId: string) => undefined,
    getTargetCareer: (categoryId: string) => [],

    // 講座：SOMPO NEWS
    getSompoNewsCategoryId: () => "",
    isSompoNews: (careerId: string) => false,

    // 講座：情報発信
    getSubmissionCategoryId: () => "",
    isSubmission: (careerId: string) => false,

    // カリキュラム関連
    CURRICULUMS: [],
    getMainCategoryCurriculum: (careerId: string) => undefined,
    getLevelCategoriesCurriculum: (parentId: string) => undefined,
    showCurriculums: () => false,
};

const fetchCategories = async (): Promise<Categories> => {
    let careerTree: TreeListItem | undefined;
    const dataSet = (treeList: TreeListItem[]) => {
        /* ==================================
         * 講座
         * ==================================
         */
        // 研修のツリーを抜き出し：コレだけが作業対象
        careerTree = (treeList || []).find((e: TreeListItem) => e.id === CATEGORY_ID_CAREERS);

        // 講座データをクリア
        CATEGORIES.clear();
        CAREERS.clear();
        LEVEL_CATEGORIES.clear();
        SOMPO_NEWS.clear();
        SUBMISSION.clear();

        // 分類ごとで処理分け
        (careerTree?.children || []).forEach((rootCategory: TreeListItem) => {
            // 講座を分類でグルーピングする。
            setupCareers(rootCategory);

            switch (rootCategory.text) {
                // SOMPO NEWSは講座比較用に講座IDをリストしておく
                // ホーム：SOMPONEWSを表示するために使用する
                case CATEGORY_NAME_SOMPO_NEWS:
                    setupSompoNews(rootCategory);
                    break;

                // 情報発信は講座比較用に講座IDをリストしておく
                // ホーム：情報発信を表示するために使用する
                case CATEGORY_NAME_SUBMISSION:
                    setupSubmission(rootCategory);
                    break;

                default:
                    break;
            }
        });

        /* ==================================
         * カリキュラム
         * ==================================
         */
        // カリキュラムのツリーを抜き出し：コレだけが作業対象
        const curriculumTree = (treeList || []).find((e: TreeListItem) => e.id === CATEGORY_ID_CURRICULUMS);

        // 既存データをクリア
        CURRICULUM_CATEGORIES.clear();
        CURRICULUMS.clear();
        CURRICULUM_LEVEL_CATEGORIES.clear();
        CURRICULUM_HISTORIES.clear();

        // カテゴリデータ作成
        (curriculumTree?.children || []).forEach((rootCategory: TreeListItem) => {
            // カリキュラムを分類でグルーピングする。
            // console.log("useCategories: Curriculum category", rootCategory);
            setupCurriculums(rootCategory);
        });
    };

    try {
        // 分類データをfetch
        await categoryCareerTreeService.categoryCareerTree(
            {},
            (response: CategoryCareerTreeResponse) => {
                dataSet(response.treeList);
            },
            (error: any) => {
                throw error;
            }
        );

        // カリキュラムの履歴をfetch
        await onGoingCULService.fetch().then((response) => {
            (response.onGoingCULGridList || []).forEach((o) => CURRICULUM_HISTORIES.add(o));
        });
        await resultCULService.fetch().then((response) => {
            (response.resultCULGridList || []).forEach((r) => CURRICULUM_HISTORIES.add(r));
        });

        return {
            // 講座：全般
            categoriesData: Array.from(CATEGORIES),
            careersData: CAREERS,
            getTargetCategory: getMainCategory,
            getLevelCategories,
            getTargetCareer,

            // 講座：SOMPO NEWS
            getSompoNewsCategoryId,
            isSompoNews,

            // 講座：情報発信
            getSubmissionCategoryId,
            isSubmission,

            // カリキュラム
            CURRICULUMS: Array.from(CURRICULUM_CATEGORIES),
            getMainCategoryCurriculum,
            getLevelCategoriesCurriculum,
            showCurriculums,
        };
    } catch (error: any) {
        console.error(error);
        showErrorMessage({ message: "分類マスタのデータ取得に失敗しました。", error });
        return CATEGORIES_DEFAULT;
    }
};
export const useCategories2 = () => ({ fetchCategories });

export interface CategoryTree {
    showCurriculums: () => boolean;
    getChildren: (parentId: string) => CategoryTreeItem[];
}
export const CATEGORY_TREE_DEFAULT: CategoryTree = {
    showCurriculums: () => false,
    getChildren: () => [],
};
/** 分類のリスト：研修(階層なし) */
const CATEGORY_TREE_CAREER: Set<CategoryTreeItem> = new Set();
/** 分類のリスト：カリキュラム(階層なし) */
const CATEGORY_TREE_CURRICULUM: Set<CategoryTreeItem> = new Set();
/** 分類のリスト：親子関係(研修・カリキュラム) */
const CATEGORY_TREE_PARENTS: Map<string, CategoryTreeItem[]> = new Map();
const CATEGORY_TREE_CURRICULUM_HISTORIES: Set<OnGoingCULGridListItem | ResultCULGridListItem> = new Set();
/* fetchCategoryTreeは第1階層の分類(#0 / #10 / #90)の要素もカウント対象になるのでsizeが必ず1以上となる。
 * 保持するデータ形式の見直しの際、useCategories2()と同様の持ち方にすることが望ましい。 */
const hasCurriculumCategoriesCategoryTree = () => CATEGORY_TREE_CURRICULUM.size > 1;
const hasCurriculumHistoriesCategoryTree = () => CATEGORY_TREE_CURRICULUM_HISTORIES.size !== 0;
const showCurriculumsCategoryTree = () => hasCurriculumCategoriesCategoryTree() || hasCurriculumHistoriesCategoryTree();
const setupCategoryTree = (item: CategoryTreeItem, targetSet: Set<CategoryTreeItem>, parent?: CategoryTreeItem): void => {
    // SOMPO NEWS/情報発信は処理対象外
    switch (item.text) {
        case CATEGORY_NAME_SOMPO_NEWS:
        case CATEGORY_NAME_SUBMISSION:
            return;

        default:
            break;
    }

    // フラット構造のリストに追加
    targetSet.add(item);

    // 子分類の設定
    const children = item.children || [];
    if (!children.length) return;
    children.forEach((child) => setupCategoryTree(child, targetSet));
    CATEGORY_TREE_PARENTS.set(item.id, item.children || []);
};
const getChildren = (parentId: string): CategoryTreeItem[] => CATEGORY_TREE_PARENTS.get(parentId) || [];
const fetchCategoryTree = async (): Promise<CategoryTree> => {
    try {
        // 分類階層をクリア、新たにfetch
        CATEGORY_TREE_CAREER.clear();
        CATEGORY_TREE_CURRICULUM.clear();
        CATEGORY_TREE_PARENTS.clear();
        await categoryTreeService.fetch({}).then((response: CategoryTreeResponse) => {
            // 研修・カリキュラムだけデータ構築
            (response.treeList || []).forEach((root: CategoryTreeItem) => {
                let targetSet: Set<CategoryTreeItem> | undefined;
                switch (root.id) {
                    case CATEGORY_ID_CAREERS:
                        targetSet = CATEGORY_TREE_CAREER;
                        break;
                    case CATEGORY_ID_CURRICULUMS:
                        targetSet = CATEGORY_TREE_CURRICULUM;
                        break;
                    default:
                        break;
                }

                if (!targetSet) return;
                setupCategoryTree(root, targetSet);
            });
        });

        // カリキュラム履歴をクリア、新たにfetch
        CATEGORY_TREE_CURRICULUM_HISTORIES.clear();
        await onGoingCULService.fetch().then((response) => {
            (response.onGoingCULGridList || []).forEach((o) => CATEGORY_TREE_CURRICULUM_HISTORIES.add(o));
        });
        await resultCULService.fetch().then((response) => {
            (response.resultCULGridList || []).forEach((r) => CATEGORY_TREE_CURRICULUM_HISTORIES.add(r));
        });

        return {
            showCurriculums: showCurriculumsCategoryTree,
            getChildren,
        };
    } catch (error: any) {
        console.error(error);
        showErrorMessage({ message: "分類マスタのデータ取得に失敗しました。", error });
        return CATEGORY_TREE_DEFAULT;
    }
};
export const useCategoryTree = () => ({ fetchCategoryTree });
